import React, { useState, useEffect } from "react";
import classes from "./SendFeedback.module.css";
import Colors from "../../../../../stories/assets/Colors";
import Fonts from "../../../../../stories/assets/Fonts";
import ModalSkeleton from "../../../../ModalSkeleton/ModalSkeleton";
import { Button } from "../../../../../stories/Button/Button";
import { TextArea } from "../../../../../stories/TextArea/TextArea";
import Ratings from "react-star-ratings";
import { isMobileViewHook } from "../../../../../CustomHooks/isMobileViewHook";
import modalClasses from "../../../../ModalSkeleton/ModalSkeleton.module.css";

export const SendFeedbackModal = ({ show, setShow, title, detailsLabel }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [rating, setRating] = useState(0)

  useEffect(() => {
    isMobileViewHook(setIsMobile);
  }, []);
  const [detail, setDetail] = useState();
  return (
    <>
      <style>{`
      .modal-body{
        padding:32px;
        padding-top:0;
      }
              @media screen and (max-width: 580px) {
            .modal .modal-dialog {
              width: 90% !important;
              margin: 0px 10%;
            }
        }
            @media screen and (max-width: 768px) {
                .${modalClasses.body} {
                  padding:0px 24px;
                }
                .${modalClasses.header} {
                    margin:24px;
                  }
            }

      `}</style>
      <ModalSkeleton
        show={show}
        setShow={setShow}
        hideHeaderBorder
        headerStyles={{ marginBottom: "0px", paddingBottom: "24px" }}
        borderRadius={"20px"}
        footerStyles={
          isMobile
            ? {
              padding: "16px 24px",
              margin: "0px",
            }
            : {
              padding: "16px 32px",
              margin: "0px",
            }
        }
        width={"509px"}
        header={
          <div>
            <h4
              style={
                isMobile
                  ? {
                    ...Fonts.h5,
                    fontSize: "24px",
                    lineHeight: "32px",
                    color: Colors.neutralShadesOfNero,
                  }
                  : {
                    ...Fonts.h4,
                    fontSize: "26px",
                    color: Colors.neutralShadesOfNero,
                  }
              }
            >
              {title}
            </h4>
          </div>
        }
        footer={
          <div className={classes.footerBtns}>
            <Button
              label={"Cancel"}
              primary={false}
              size={"Large"}
              customStyle={{
                width: "95px",
                marginRight: "24px",
                backgroundColor: Colors.white,
                border: "none",
                ...Fonts.b2,
                lineHeight: "20px",
              }}
            />
            <Button
              label={"Submit"}
              primary={true}
              size={"Large"}
              customStyle={{
                width: "120px",
                height: "48px",
                ...Fonts.b2,
                lineHeight: "20px",
              }}
            />
          </div>
        }
      >
        <div className={classes.modalContent}>
          <div className={[].join(" ")}>
            <div>
              <p className={[classes.mb24].join(" ")} style={{ ...Fonts.p1 }}>
                How would you rate your experience?
              </p>
              <div
                className={[classes.mb32, classes.pb32].join(" ")}
                style={{
                  borderBottom: `1px solid ${Colors.neutralShadesOfWhisper}`,
                }}
              >
                <Ratings
                  numberOfStars={5}
                  starRatedColor={Colors.mainShadeOfRed}
                  starEmptyColor={Colors.neutralShadesOfGainsboro}
                  rating={rating}
                  changeRating={(e) => setRating(e)}
                  starDimension="40px"
                  starSpacing={3}
                />
              </div>
            </div>
            <TextArea
              state={detail}
              setter={setDetail}
              label={`${detailsLabel}`}
              placeholder="Details"
            />
          </div>
        </div>
      </ModalSkeleton>
    </>
  );
};
